<template>
  <!--<div id="homePage-3">
    <h1>{{ msg }}</h1>
  </div>-->
   
  <div >
    <div id="page3-img">
      <template v-if="imgs&&imgs.length">
        <div  v-for="(imgObj,index) in imgs" v-bind:key="index" >
          <img class="imgs" :src="require('../../../assets/img/'+imgObj.img)" />
        </div>
      </template>
    </div>
    <div>
      <!-- <div class="part-title">
        <h3>企业营销解决方案</h3>
        <p>尚禾维曼开启您企业互联网大门的启蒙老师，为企业互联网保驾护航</p>
      </div> -->
      <div class="part-content">
        <!-- <div class="part-swiper">
          <div class="swiper-left">
            <h3>品牌策划</h3>
            <span class="Grader"></span>
            <p>搭建一套完善的计划方案，将线下的产品快速引导到线上来达到增容的效果，打破传统营销的平静</p>
          </div>
          <div class="swiper-right">
            <img src="~assets/img/banner/img_pinpaicehua.jpg" alt="sashereman">
          </div>
        </div> -->
      
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: 'PageThree',
  data () {
    return {
      // imgs: [
      //   {
      //     img: "https://cos.dhfapp.com/goimg/0261095a-5d6f-43ed-ae23-aa0dc17a1f1c.jpg"
      //   }
      // ]
    }
  },
  created () {
    // ...
    if(this.configData){
      // this.configData.page3Imgs.map(function(img){
      //   console.error(img);
      //   // img.img=require(img.img);
      // })
      this.imgs=this.configData.page3Imgs
    }
  }
}
</script>
<style lang="scss" scoped>
#homePage-3 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  // background: url("~assets/img/banner/BGxian.png") center no-repeat,
  //             url('~assets/img/banner/page1_bgbg.jpg') center no-repeat;
  // color: #fff;
  >div {
    margin: auto;
  }
}
  .imgs {
    width:100%;
    height:auto;
    object-fit: contain; 
    display: block;
  }
  .page-left {
  h1 {
    font-size: 58px;
    margin-bottom: 50px;
    span {
      margin-right: 50px;
    }
  }
  h3 {
    font-size: 36px;
    margin-bottom: 50px;
    text-align: left;
  }
  .view-detail {
    font-size: 16px;
    line-height: 60px;
    display: block;
    width: 216px;
    height: 60px;
    transition: all .3s;
    text-align: center;
    border: 1px solid #fff;
    border-radius: 4px;
    color: #fff;
    margin-bottom:15px;
    &:hover {
      color: #072c69;
      background-color: #fff;
    }
  }
}
</style>
